// const EntranceExam = () => {
//     const [tab, setTab] = useState(0);

//     return (
//         <>
//             <div className="flex flex-col lg:flex-row justify-between mb-5 items-center px-3 gap-5 py-3 max-w-[60%] cursor-pointer rounded-lg bg-[#691e78]/40">
//                 <div
//                     className={
//                         tab === 0 ? "bg-white px-5 py-3 rounded-lg ring-1 ring-black text-nowrap" : ""
//                     }
//                     onClick={() => setTab(0)}
//                 >
//                     <p>Examiner/Supervisor Setup</p>
//                 </div>
//                 <div
//                     className={
//                         tab === 1 ? "bg-white px-5 py-3 rounded-lg ring-1 ring-black text-nowrap" : ""
//                     }
//                     onClick={() => setTab(1)}
//                 >
//                     <p>QUestion Setup</p>
//                 </div>
//                 <div
//                     className={
//                         tab === 2 ? "bg-white px-5 py-3 rounded-lg ring-1 ring-black text-nowrap" : ""
//                     }
//                     onClick={() => setTab(2)}
//                 >
//                     <p>Exam Bank</p>
//                 </div>
//             </div>

//             {tab === 0 && (
//                 <div>
//                     <div className="flex justify-between mb-5">
//                         <div className="text-[20px] font-700">Examiner/Supervisors Setup</div>
//                         <div
//                             className="w-[300px] cursor-pointer items-center text-white bg-[#691e78] hover:bg-[#691e78]/90 flex justify-center px-5 py-3 rounded-lg"
//                             onClick={handleOpenModal}
//                         >
//                             Add Exam Type
//                         </div>
//                     </div>
//                     <div>
//                         <SetUpTable />
//                     </div>
//                     <Modal
//                         open={openModal}
//                         onClose={handleCloseModal}
//                         aria-labelledby="modal-modal-title"
//                         aria-describedby="modal-modal-description"
//                     >
//                         <Box sx={style}>
//                             <Box align="right" sx={{}}>
//                                 <IconButton onClick={handleCloseModal}>
//                                     <HighlightOffIcon />
//                                 </IconButton>
//                             </Box>
//                             <Box>
//                                 <Typography
//                                     variant="h4"
//                                     sx={{ textAlign: "center", mb: 2, fontFamily: "Gilroy-Medium" }}
//                                 >
//                                     Add Exam Type
//                                 </Typography>
//                                 <Divider />
//                             </Box>
//                             <Box p={3} sx={{ overflowY: "scroll", height: "450px" }}>
//                                 <Grid container spacing={2}>
//                                     <Grid item sm={6} xs={12}>
//                                         <Box>
//                                             <InputLabel
//                                                 sx={{
//                                                     mb: 1.5,
//                                                     mt: 1,
//                                                     fontSize: "12px",
//                                                     fontWeight: "bolder",
//                                                     color: "#000",
//                                                     fontFamily: "Gilroy-Medium",
//                                                 }}
//                                             >
//                                                 School Year
//                                             </InputLabel>
//                                             <FormControl fullWidth>
//                                                 <Select
//                                                     name="sessionId"
//                                                     sx={{
//                                                         fontFamily: "Gilroy-Regular",
//                                                         border: "0.5px solid #fff",
//                                                         "& .MuiOutlinedInput-root": {
//                                                             "& fieldset": {
//                                                                 border: "1px solid #fff",
//                                                             },
//                                                         },
//                                                     }}
//                                                     variant="outlined"
//                                                     size="small"
//                                                     value={selectedSession.sessionId}
//                                                     onChange={handleChange}
//                                                     disabled={sessionsLoading}
//                                                 >
//                                                     {sessionsLoading ? (
//                                                         <MenuItem disabled>Loading session...</MenuItem>
//                                                     ) : !sessions?.data || sessions.data.length === 0 ? (
//                                                         <MenuItem disabled>No session available</MenuItem>
//                                                     ) : (
//                                                         sessions.data.map((session) => (
//                                                             <MenuItem
//                                                                 sx={{ fontFamily: "Gilroy-Regular" }}
//                                                                 value={session.id}
//                                                                 key={session.id}
//                                                             >
//                                                                 {session.name}
//                                                             </MenuItem>
//                                                         ))
//                                                     )}
//                                                 </Select>
//                                             </FormControl>
//                                         </Box>
//                                     </Grid>
//                                     <Grid item sm={6} xs={12}>
//                                         <Box>
//                                             <InputLabel
//                                                 sx={{
//                                                     mb: 1.5,
//                                                     mt: 1,
//                                                     fontSize: "12px",
//                                                     fontWeight: "bolder",
//                                                     color: "#000",
//                                                     fontFamily: "Gilroy-Medium",
//                                                 }}
//                                             >
//                                                 Class
//                                             </InputLabel>
//                                             <FormControl fullWidth>
//                                                 <Select
//                                                     name="classId"
//                                                     sx={{
//                                                         fontFamily: "Gilroy-Regular",
//                                                         border: "0.5px solid #fff",
//                                                         "& .MuiOutlinedInput-root": {
//                                                             "& fieldset": {
//                                                                 border: "1px solid #fff",
//                                                             },
//                                                         },
//                                                     }}
//                                                     variant="outlined"
//                                                     size="small"
//                                                     value={selectedClasses.classId}
//                                                     onChange={handleChangeClass}
//                                                     disabled={isLoading}
//                                                 >
//                                                     {isLoading ? (
//                                                         <MenuItem disabled>Loading class...</MenuItem>
//                                                     ) : !classAndArm?.data || classAndArm.data.length === 0 ? (
//                                                         <MenuItem disabled>No session available</MenuItem>
//                                                     ) : (
//                                                         classAndArm.data.map((item) => (
//                                                             <MenuItem
//                                                                 sx={{ fontFamily: "Gilroy-Regular" }}
//                                                                 value={item.classId}
//                                                                 key={item.classId}
//                                                             >
//                                                                 {item.className} {item.classArm}
//                                                             </MenuItem>
//                                                         ))
//                                                     )}
//                                                 </Select>
//                                             </FormControl>
//                                         </Box>
//                                     </Grid>
//                                 </Grid>
//                                 <Box mt={10}>
//                                     <Button
//                                         variant="contained"
//                                         fullWidth
//                                         sx={{ textTransform: "initial", backgroundColor: "#691e78" }}
//                                         onClick={handleSubmit}
//                                         disabled={loading}
//                                     >
//                                         {loading ? "Adding..." : "Add TimeTable"}
//                                     </Button>
//                                 </Box>
//                             </Box>
//                         </Box>
//                     </Modal>
//                 </div>
//             )}

//             {tab === 1 && (
//                 <div>
//                     <div className="flex bg-[#691e78] px-3 py-3 gap-3 mb-5 rounded-lg">

//                         <div className="items-center text-[#691e78] bg-white flex justify-center px-10 py-3 rounded-sm">
//                             Load
//                         </div>
//                     </div>
//                     <div className="ring-1 ring-[#691e78] rounded-xl ">
//                         <ComponentWrapper />
//                     </div>
//                 </div>
//             )}

//             {tab === 2 && (
//                 <div>
//                     <div className="flex bg-[#691e78] px-3 py-3 gap-3 mb-5 rounded-lg">

//                         <div className="items-center text-[#691e78] bg-white flex justify-center px-10 py-3 rounded-sm">
//                             Load
//                         </div>
//                     </div>
//                     <div className="ring-1 ring-[#691e78] rounded-xl ">
//                         <ComponentWrapper />
//                     </div>
//                 </div>
//             )}
//         </>
//     );
// };
// export default EntranceExam

const EntranceExam = () => {
  return (
    <div>EntranceExam</div>
  )
}

export default EntranceExam